<ng-content></ng-content>

<cm-inspector-section>
    <ng-container cm-title> Plane Guide </ng-container>
    <ng-container cm-content>
        <cm-value-slot [node]="$node()" [key]="'width'" [label]="'Width'" [min]="1" [max]="500" [numberModifier]="'slider'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'height'" [label]="'Height'" [min]="1" [max]="500" [numberModifier]="'slider'"></cm-value-slot>
    </ng-container>
</cm-inspector-section>
